export default __webpack_public_path__ + "static/media/img-upload.bf1f58e1.svg";